import dayjs from 'dayjs';

const FULL_DATE = 'MMMM D, YYYY';
const DATE_WITHOUT_YEAR = 'MMMM D';
const TIME_OF_DAY = 'h:mm A';

/**
 * Formats a date for display. Missing or unparseable values return an empty
 * string rather than "Invalid Date", so callers can render the result directly.
 * @param {String|Date} value The date to format
 * @param {String} format An optional dayjs format string
 * @returns {String} The formatted date, or an empty string
 */
export const formatDate = (value, format = FULL_DATE) => {
  const date = dayjs(value);
  return value && date.isValid() ? date.format(format) : '';
};

/**
 * Formats a date the way list columns want it: the year is dropped for dates in
 * the current year, so recent rows stay short.
 * @param {String|Date} value The date to format
 * @returns {String} The formatted date, or an empty string
 */
export const formatListDate = (value) => {
  const date = dayjs(value);
  if (!value || !date.isValid()) return '';
  return date.format(date.year() === dayjs().year() ? DATE_WITHOUT_YEAR : FULL_DATE);
};

/**
 * Formats the time of day a page reports something it has just done — "3:42 PM".
 * @param {String|Date} value The moment to format
 * @returns {String} The formatted time, or an empty string
 */
export const formatTime = (value) => {
  const time = dayjs(value);
  return value && time.isValid() ? time.format(TIME_OF_DAY) : '';
};
